import { getPrinterPaperWidthMm } from "./profile";

export async function printBrowser({
  document = null,
  printer = {},
} = {}) {
  const receiptElements = Array.from(
    document?.type
      ? window.document.querySelectorAll(".receipt-print")
      : []
  );

  const paperWidth = getPrinterPaperWidthMm(printer?.paper_width);

  const previousValues = receiptElements.map((element) => ({
    element,
    value: element.style.getPropertyValue("--gloo-paper-width"),
  }));

  receiptElements.forEach((element) => {
    element.style.setProperty("--gloo-paper-width", paperWidth);
  });

  try {
    window.print();
  } finally {
    receiptElements.forEach(({ element, value }) => {
      if (value) {
        element.style.setProperty("--gloo-paper-width", value);
      } else {
        element.style.removeProperty("--gloo-paper-width");
      }
    });
  }

  return {
    success: true,
    adapter: "browser",
    document_type: document?.type || "receipt",
    paper_width: paperWidth,
  };
}
